import React from 'react'
import TabButton from '../ui/TabButton/TabButton'
import styles from './KnowledgeCenterLayout.module.scss'
import { Outlet } from 'react-router-dom'
import classNames from 'classnames'

const KnowledgeCenterLayout = ({ data, pagination, emptyMessage = '' }) => {
  const tabs = data?.innertabs

  const pageData = {
    data,
    pagination,
    emptyMessage,
  }
  return (
    <div>
      <div
        className={classNames(
          'tabs-container',
          'left-tabs-container',
          styles['button-wrapper']
        )}
      >
        {tabs?.map((tab) => {
          return (
            <TabButton
              key={'knowledgeTab' + tab?.id}
              label={(tab?.link?.label || '').toUpperCase()}
              path={tab?.link?.path}
              type="link"
              buttonClassname={styles['button-container']}
              activeButtonClassname={styles['active-button']}
              inactiveButtonClassname={styles['inactive-button']}
            />
          )
        })}
      </div>
      <Outlet context={pageData} />
    </div>
  )
}

export default KnowledgeCenterLayout
